import * as formulas from "../operations/show_formulas";

export function showFormulas(state){
	formulas.showFormulas(this, state);
}